import { Injectable } from '@angular/core';
import { isNullOrUndefined } from "@swimlane/ngx-datatable";
import { CultureLocaleService } from '../Services/culture-locale.service';
import { localStorageKeys } from './../Models/configurations';
import { CommonLocalizationService } from './common-localization.service';
import { SecureStorageService } from './secure-storage.service';
import { ClientAppLogout } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Injectable()
export class AppConfigService {
  public version: string;
  public apiEndpointSomeData: string;
  ipAddress: any;
  langcode:string;

  constructor(
    private readonly secureStorageService: SecureStorageService,
    private readonly commonLocalizationService: CommonLocalizationService,
    private cultureLocaleService:CultureLocaleService
  ) {

  }

  public getParameterByName() {
   const url = window.location.href;
    const regex = /[?&=](([^&#]*)|&|#|$)/,
      results = regex.exec(url);
    if (!results) { return null; }
    if (!results[2]) { return ''; }
    return results[2];
  }

  public load(): Promise<string> {
    return Promise.resolve(this.getParameterByName());
  }
  async getIP(){
    localStorage.setItem('ipAdd', null);
    return null;
  }
  async initialise() {
    await this.getIP();
    await this.cultureLocaleService.initialise();
    this.secureStorageService.removeKey(localStorageKeys.tinyUrl);
    let param = this.getParameterByName();
    if (!isNullOrUndefined(param)) {
      if(param.includes("?"))
      {
        this.langcode=param.substring(param.indexOf("?")+1);
        // task - 8584 - bypass validation input if number plate is in route
        if (this.langcode.includes('?')) {
          const [langCode, plate] = this.langcode.split('?');
          this.secureStorageService.setKeyData(localStorageKeys.autoCarPlate, plate);
          this.langcode = langCode;
        }
        this.commonLocalizationService.customerDefaultLanguage=this.langcode;
        param=param.substring(0, param.indexOf("?"));
      }
      ClientAppLogout();
      this.secureStorageService.setKeyData(localStorageKeys.tinyUrl, param);
      this.secureStorageService.setKeyData(localStorageKeys.unauthorizeUser,false);
    } else {
      this.secureStorageService.setKeyData(localStorageKeys.checkInParams, 0);
      this.secureStorageService.setKeyData(localStorageKeys.unauthorizeUser, true);
    }

  }
}
